module.exports = __webpack_public_path__ + "img/year-changer.98e718a2.svg";